import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { useLanguage } from '../contexts/LanguageContext';
const TermsOfService = () => {
  const L = useLanguage();
  return (
    <>

	<Navbar />
      <div className="container-fluid text-center" style={{ backgroundColor: 'white' }}>
	 	 <div className="text-center">

				<h1 className="pt-4 text-instagram"><strong>{L.terms.title}</strong></h1>


		  </div>
        <div className="row justify-content-center text-center mt-2">
          <div id="pricing" style={{ fontSize: '15px', width: '100%' }}>
            <p>
              {L.terms.intro}
            </p>
            <p>
              {L.terms.serviceDescription}
            </p>
            <p>
              {L.terms.userConduct}
            </p>
            <ul>
              {L.terms.conductList.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p>
              {L.terms.payment}
            </p>
            <p>
              {L.terms.ip}
            </p>
            <p>
              {L.terms.warranties}
            </p>
            <p>
              {L.terms.liability}
            </p>
            <p>
              {L.terms.indemnification}
            </p>
            <p>
              {L.terms.cancellation}
            </p>
            <p>
              {L.terms.refundPolicy}
            </p>
            <p>
              {L.terms.contact}
            </p>
            <p>
              {L.terms.agreement}
            </p>
          </div>
        </div>
      </div>
	  <Footer />
    </>
  );
};

export default TermsOfService;
